import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ResultsSearchService } from 'app/home/results-search.service';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { ItineraryService } from 'app/shared/itinerary.service';
import { RestService } from 'app/shared/rest.service';
import { IProductBase, IProductCreationParams, IProductDeleteParams, IProductReservationBase, IProductReservationParams, IProductService } from 'model/product.interface';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseProductService implements IProductService {

  constructor(
              protected itineraryService: ItineraryService,
              protected userService: UserService,
              protected resultsSearch: ResultsSearchService,
              protected dialog: MatDialog,
              protected restService: RestService,
              protected router: Router,
              protected modalService: BsModalService,
              protected ngxSpinner: NgxSpinnerService,
              protected toastr: ToastrService
            ) {}

  abstract createProduct(params: IProductCreationParams): IProductBase;

  abstract createReserve(params: IProductReservationParams): IProductReservationBase;

  abstract deleteProduct(params: IProductDeleteParams): IProductBase;

  abstract validateProduct(item: any): boolean;

}
